var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import * as authAPI from '@debbie/cortex/dist/api/auth';
import { Button, Input } from '../..';
const Reset = (props) => {
    const [username, setUsername] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    // TODO: Lang
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: (e) => __awaiter(void 0, void 0, void 0, function* () {
                console.log(e);
                e.preventDefault();
                e.stopPropagation();
                try {
                    yield authAPI.initiatePasswordReset(username);
                    props.onReset(username);
                }
                catch (err) {
                    console.error(err);
                    setError(err === null || err === void 0 ? void 0 : err.message);
                    setLoading(false);
                }
            }) },
            error !== '' ? React.createElement("div", { className: "warning" }, error) : null,
            React.createElement(Input, { placeholder: "E-mail", value: username, onChange: (e) => {
                    setUsername(e.target.value);
                } }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' }, loading: loading }, "Nulstil"),
            React.createElement(Button, { block: true, onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onCancel();
                }, theme: "secondary" }, "Annuller"))));
};
export default Reset;
//# sourceMappingURL=Reset.js.map